import {
  $createApiKey,
  $deleteApiKey,
  $deleteApiKeys,
  $getApiKey,
  $getApiKeys,
  $recoverApiKey,
  $revokeApiKey,
  createApiKey,
  deleteApiKey,
  deleteApiKeys,
  getApiKey,
  getApiKeys,
  recoverApiKey,
  revokeApiKey,
} from './actionCreators';
import reducer from './reducer';
import sagas from './sagas';

export default {
  sagas,
  reducer,
  actions: {
    createApiKey,
    deleteApiKey,
    revokeApiKey,
    getApiKey,
    getApiKeys,
    deleteApiKeys,
    recoverApiKey,
  },
};

export const $actions = {
  createApiKey: $createApiKey,
  getApiKey: $getApiKey,
  getApiKeys: $getApiKeys,
  deleteApiKeys: $deleteApiKeys,
  deleteApiKey: $deleteApiKey,
  revokeApiKey: $revokeApiKey,
  recoverApiKey: $recoverApiKey,
};
